import { render, staticRenderFns } from "./CrossEarlyBirds.vue?vue&type=template&id=37468782&name=new-cross-early-birds&"
import script from "./CrossEarlyBirds.vue?vue&type=script&lang=js&"
export * from "./CrossEarlyBirds.vue?vue&type=script&lang=js&"
import style0 from "./CrossEarlyBirds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CrossEarlyBirds.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports